import { API } from '@Providers';

export default async function () {
  const endpoint = '/api/shelter/help-tip-texts';

  return API({ endpoint, method: 'get' });
}
